const logActions = {
  PASSWORD_RESET: { name: 'passwordReset', description: 'Investor requests a password reset' },
  LOGIN: { name: 'login', description: 'Investor logs in to the system' },
  LOGIN_FAILED: { name: 'loginFailed', description: 'Somebody attempts to login to the system but with invalid credentials' },
  ADD_FUNDING_SOURCE: { name: 'addFundingSource', description: 'Investor adds a new funding source' },
  VIEW_INVESTOR_IMPACT_PREFERENCES: { name: 'viewInvestorImpactPreferences', description: 'Investor view preferences he selected' },
  DOCUMENT_VIEW: { name: 'documentView', description: 'Investor selects a document for view' },
};

export default logActions;



// WEBPACK FOOTER //
// ./src/data/static/logActions.js